import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {Create, Add} from '@mui/icons-material'
import Tooltip from '@mui/material/Tooltip'
import Dialog from 'components/Dialog'
import RelationConfig from './RelationConfig'

const Preset = styled.div`
    background-color: rgba(160, 183, 190, .24);
    align-items: center;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    height: 25px;
    width: 25px;
    min-width: 25px;
    transition: background-color 250ms cubic-bezier(.55, 0, .1, 1);

    :not(:first-child) {
        margin-left: 20px;
    }

    :hover {
        background-color: rgba(160, 183, 190, .35);
    }
`

const Relation = styled.div`
    display: flex;
    align-items: center;
    padding-right: ${props => props.mobile ? '20px' : '35px'};
    /* overflow: hidden; */
    position: relative;
    height: 100%;
    cursor: pointer;

    :last-child {
        padding-right: ${props => props.mobile ? '0' : '35px'};
    }

    svg {
        display: none;
        font-size: 20px;
        position: absolute;
        right: 0;
        padding: 0 10px 0 5px;
        background: #fff;
    }

    :hover {
        a {
            color: #4a4a4a;
        }

        svg {
            display: block;
        }
    }

    a {
        color: #7c9198;
        cursor: pointer;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 300px;
        overflow: hidden;
        font-weight: 700;
        height: 100%;
        display: flex;
        align-items: center;
    }
`

const Bottom = styled.div`
    height: 52px;
    align-items: center;
    display: flex;
    padding: ${props => props.mobile ? '0 10px' : '0 16px 0 96px'};
    box-sizing: border-box;
    background-color: #fff;
`

const Relations = styled.div`
    display: flex;
    align-items: center;
    overflow: auto;
    height: 100%;
`

class RecordBottom extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
            relation: null
        }
    }

    handleOpen = (id) => {
        this.setState({
            open: true,
            relation: id
        })
    }

    handleClose = () => {
        this.setState({
            open: false,
            relation: null
        })
    }

    render() {
        const {intl, mobile} = this.props

        return (
            <React.Fragment>
                <Bottom mobile={mobile}>
                    {!!this.props.relations.length &&
                        <Relations>
                            {this.props.relations.map((item, index) =>
                                <Relation key={index} mobile={mobile}>
                                    <Link to={`/relation/${item.id}/${this.props.recordId}`}>{item.name}</Link>
                                    {!mobile && this.props.permissions.Designer &&
                                        <Create onClick={() => this.handleOpen(item.id)} />
                                    }
                                </Relation>
                            )}
                        </Relations>
                    }
                    {this.props.permissions.Designer &&
                        <Tooltip
                            title={intl.formatMessage({id: "record.new_relation"})}
                            placement="top"
                        >
                            <Preset onClick={() => this.handleOpen()}>
                                <Add />
                            </Preset>
                        </Tooltip>
                    }
                </Bottom>
                <Dialog
                    open={!!this.state.open}
                    onClose={this.handleClose}
                    fullWidth
                >
                    <RelationConfig
                        entities={this.props.entities}
                        entityId={this.props.entityId}
                        onClose={this.handleClose}
                        handleCreate={this.props.createRelation}
                        handleUpdate={this.props.updateRelation}
                        config={this.props.relations.find(item => item.id === this.state.relation)}
                    />
                </Dialog>
            </React.Fragment>
        )
    }
}

export default injectIntl(RecordBottom)
